import { getToken, plurallClient } from './index'

const getProfile = async () => {
  const token = getToken()

  if (!token) {
    return
  }

  const client = plurallClient()

  await client.profile.get()
}

export default getProfile
